import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import createBotData from "./modules/createBotData";
import loading from "./modules/loading";
import users from "./modules/users";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    auth,
    users,
    createBotData,
    loading,
  },
});
